import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Download, Brain, Search, FileText, Smartphone, ShieldCheck, Zap, Clock, Gift } from 'lucide-react';
import { Countdown } from './components/Countdown';
import { TestimonialCarousel } from './components/TestimonialCarousel';
import { FAQAccordion } from './components/FAQAccordion';
import { PurchasePopup } from './components/PurchasePopup';
import { useGeoPrice } from './hooks/useGeoPrice';
const COVER_MURDOKU = 'https://cdn.magicpatterns.com/uploads/uQ8iEyyUoUxqkZm4STZ1gN/PORTADA_MURDOKU.webp';
const COVER_VIAJE = 'https://cdn.magicpatterns.com/uploads/9WL6bjUYpwm32hXAbrBtjR/MURDOKU_VIAJE_AL_PASADO.webp';
const COVER_SOFIA = 'https://cdn.magicpatterns.com/uploads/mWuxMqkfRN1b7hgPRSnQas/el_asesino_no_es_sofia.png';
const COVER_SOPICIDIOS = 'https://cdn.magicpatterns.com/uploads/bvEMUpH6ACC4MWrvDrTYQy/SOPICIDIOS.webp';
const COVER_MURDLE_1 = 'https://cdn.magicpatterns.com/uploads/fCGMdVbTpRMd9Urkc6xgfb/murdle_1.png';
const COVER_MURDLE_2 = 'https://cdn.magicpatterns.com/uploads/pLcoYvsRja15vYt1zf2Wr1/MURDLE_2.webp';
const PACK_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/fGWbqYFAMXy5r4k3t6vvfz/Diseno_sin_titulo.png';
const CHECKOUT_URL = 'https://murdoku.impultienda.ar/checkout/pack-misterios-6-en-1';
const PACK_ALT = 'Pack Misterios: seis libros digitales completos en español con Murdoku, Murdoku Viaje al Pasado, El Asesino No Es Sofía, Sopicidios y dos libros Murdle de regalo';
export function App() {
  const {
    price
  } = useGeoPrice();
  useEffect(() => {
    // Meta Pixel Code
    const win = window as any;
    if (!win.fbq) {
      win.fbq = function () {
        win.fbq.callMethod ? win.fbq.callMethod.apply(win.fbq, arguments) : win.fbq.queue.push(arguments);
      };
      if (!win._fbq) win._fbq = win.fbq;
      win.fbq.push = win.fbq;
      win.fbq.loaded = !0;
      win.fbq.version = '2.0';
      win.fbq.queue = [];
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    win.fbq('init', '1052676944287139');
    win.fbq('track', 'PageView');
  }, []);
  const scrollToCheckout = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen font-sans text-[#1E1E1E] bg-[#F7F1E3] overflow-x-hidden" data-id="element-0" data-mp="3gklau424hi7l">
      <PurchasePopup data-id="element-1" data-mp="3bmtgl3e09k08" />

      {/* 1. Top Bar */}
      <div className="bg-[#1E1E1E] text-white text-center py-2 text-[11px] md:text-sm font-semibold tracking-widest uppercase px-4" data-id="element-2" data-mp="3bo4lj6j6sxsx">
        PACK MISTERIOS — 6 LIBROS EN 1 · 100% DIGITAL
      </div>

      {/* 2. Promo Bar */}
      <div className="bg-[#F97316] text-white text-center py-2.5 font-bold flex flex-wrap items-center justify-center gap-x-2 shadow-md sticky top-0 z-50 px-4" data-id="element-3" data-mp="2xuwsrbjddw9n">
        <Zap size={18} className="animate-pulse" data-id="element-4" data-mp="2svaf50zmqe0b" />
        <span className="text-xs md:text-base" data-id="element-5" data-mp="18e171cv5hagc">OFERTA POR TIEMPO LIMITADO</span>
        <Countdown data-id="element-6" data-mp="1d4hnl5u9pc6x" />
      </div>

      {/* 3. Hero Section */}
      <section className="relative bg-[#5E1A8A] text-white pt-10 pb-16 md:pt-14 md:pb-20 overflow-hidden" data-id="element-7" data-mp="1d62gys4uip37">
        <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-8" data-mp="yher92hol9l6"></div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#7B2CBF] rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3" data-id="element-9" data-mp="13fpx724uuzy4"></div>

        <div className="max-w-6xl mx-auto px-5 md:px-6 relative z-10" data-id="element-10" data-mp="1r2g1yb8l98mf">
          <div className="flex flex-col md:grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-11" data-mp="1w2tzv0gh726q">

            {/* Título */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="order-1 md:col-start-1 md:row-start-1 space-y-4 text-center md:text-left" data-id="element-12" data-mp="1i5x90z0cxkpu">
              <div className="flex flex-wrap gap-2 justify-center md:justify-start" data-id="element-13" data-mp="anwkhko08wlo">
                <span className="inline-block bg-[#F97316] text-white font-bold px-3 py-1 rounded-full text-xs md:text-sm" data-id="element-14" data-mp="qygla1jrq236">
                  PACK 6 EN 1
                </span>
                <span className="inline-block bg-white/15 border border-[#F97316]/60 text-[#FFB27A] font-bold px-3 py-1 rounded-full text-xs md:text-sm" data-id="element-15" data-mp="h8414afv8axk">
                  + 2 BONUS GRATIS
                </span>
              </div>
              <h1 className="font-heading text-[2rem] leading-[1.1] md:text-6xl font-black text-white drop-shadow-md" data-id="element-16" data-mp="19tx6mrsjq3o1">
                <span className="text-[#F97316]" data-id="element-17" data-mp="zxtt6ps8uils">6 libros</span> para resolver crímenes y misterios de lógica
              </h1>
              <p className="text-base md:text-xl text-white/85 font-medium leading-relaxed max-w-md mx-auto md:mx-0" data-id="element-18" data-mp="vx07m329xfw2">
                Analizá pistas, descartá sospechosos y convertite en detective con 4 libros principales + 2 de regalo.
              </p>
            </motion.div>

            {/* Mockup */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="order-2 md:col-start-2 md:row-start-1 md:row-span-2 relative flex justify-center w-[108%] -ml-[4%] md:w-full md:ml-0" data-id="element-19" data-mp="1w5geqt2eu05b">
              <div className="absolute inset-0 bg-[#7B2CBF] opacity-40 blur-[50px] rounded-full scale-90" data-id="element-20" data-mp="2ev6ii5o5hw9d"></div>
              <img src={PACK_IMAGE_URL} alt={PACK_ALT} className="relative z-10 w-full max-w-none md:max-w-[620px] h-auto object-contain drop-shadow-[0_20px_40px_rgba(20,5,30,0.8)]" fetchPriority="high" data-id="element-21" data-mp="2jthr6d2pm0q0" />
            </motion.div>

            {/* Lista + CTA */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="order-3 md:col-start-1 md:row-start-2 space-y-6 w-full text-center md:text-left" data-id="element-22" data-mp="2ssbm7z0e6j1g">
              <ul className="inline-grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-[15px] md:text-base text-left" data-id="element-23" data-mp="1wsr1jtlha97w">
                {[{
                name: 'El Asesino No Es Sofía',
                bonus: false
              }, {
                name: 'Sopicidios',
                bonus: false
              }, {
                name: 'Murdoku',
                bonus: false
              }, {
                name: 'Murdoku: Viaje al Pasado',
                bonus: false
              }, {
                name: 'Murdle Vol. 1 — Bonus',
                bonus: true
              }, {
                name: 'Murdle Vol. 2 — Bonus',
                bonus: true
              }].map(book => <li key={book.name} className="flex items-center gap-2" data-id="element-24" data-mp="33gxmruovx3mo">
                    <CheckCircle2 className={book.bonus ? 'text-[#F97316] shrink-0' : 'text-white shrink-0'} size={18} data-id="element-25" data-mp="33h7htwose0z8" />
                    <span className={book.bonus ? 'text-[#FFB27A] font-semibold' : ''} data-id="element-26" data-mp="3i3mx6rkod17u">{book.name}</span>
                  </li>)}
              </ul>

              <div data-id="element-27" data-mp="3n1ofvbe6uyis">
                <a href="#compra" onClick={scrollToCheckout} className="w-full md:w-auto md:inline-flex bg-[#F97316] hover:bg-[#FB8B3C] text-white font-black text-base md:text-xl py-4 px-8 rounded-xl shadow-[0_8px_0_#9A3412] hover:shadow-[0_4px_0_#9A3412] hover:translate-y-1 transition-all duration-200 flex items-center justify-center gap-3 uppercase" data-id="element-28" data-mp="3n27ou2lv2cko">
                  QUIERO EL PACK MISTERIOS
                  <Download size={20} data-id="element-29" data-mp="345evk6cp1bqc" />
                </a>
                <div className="flex items-center justify-center md:justify-start gap-2 mt-4 text-[13px] md:text-sm text-white/80 font-medium" data-id="element-30" data-mp="2pfh8xuuewu39">
                  <ShieldCheck size={16} className="text-[#F97316]" data-id="element-31" data-mp="2uebqyukk2emb" />
                  <span data-id="element-32" data-mp="2gfc49sgls9ss">Acceso inmediato · Producto 100% digital</span>
                </div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>

      {/* 3b. Qué significa "libros completos" */}
      <section className="bg-[#2A0B42] text-white py-8 md:py-10 px-5" data-id="element-33" data-mp="30ulwnlzzs7pe">
        <div className="max-w-3xl mx-auto text-center" data-id="element-34" data-mp="2vxlsxhqm7h1g">
          <h2 className="font-heading text-lg md:text-2xl font-black text-[#FFB27A] mb-3 uppercase" data-id="element-35" data-mp="2qx7m230r2d50">
            RECIBÍS LOS LIBROS COMPLETOS EN ESPAÑOL
          </h2>
          <p className="text-sm md:text-lg text-white/85 leading-relaxed" data-id="element-36" data-mp="2lxuuj4yxohw3">
            Son los libros en versión digital, completos y en español: todas las páginas, todos los casos y todas las soluciones. No son resúmenes, muestras gratuitas ni capítulos sueltos.
          </p>
        </div>
      </section>

      {/* 4. Los libros del pack */}
      <section className="py-14 md:py-20 bg-white relative" data-id="element-37" data-mp="238540u27ei9z">
        <div className="max-w-6xl mx-auto px-5 md:px-6" data-id="element-38" data-mp="235ini4xc4sfm">
          <div className="text-center mb-10 md:mb-16" data-id="element-39" data-mp="1y7h41ivzyr3m">
            <h2 className="font-heading text-2xl md:text-5xl font-black text-[#3C1361]" data-id="element-40" data-mp="1u6x5qbzothfw">
              ¿Qué incluye el Pack Misterios?
            </h2>
          </div>

          {/* Libro 1: Sofía */}
          <div className="bg-[#F7F1E3] rounded-3xl p-6 md:p-12 mb-6 md:mb-8 border border-[#F97316]/20" data-id="element-41" data-mp="dqhmbjgh5wpv">
            <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-42" data-mp="ipu9647cj3sg">
              <div className="order-1 md:order-1 flex justify-center" data-id="element-43" data-mp="inrmnu5ejssh">
                <img src={COVER_SOFIA} alt="El Asesino No Es Sofía" className="w-[68%] md:w-full max-w-xs mx-auto rounded-lg book-shadow transform -rotate-2" loading="lazy" data-id="element-44" data-mp="no5kkjdahmcs" />
              </div>
              <div className="order-2 md:order-2 space-y-4 text-center md:text-left" data-id="element-45" data-mp="3r5xi0da72yid">
                <span className="inline-block bg-[#F97316] text-white font-bold px-3 py-1 rounded-full text-[11px] md:text-xs tracking-wider" data-id="element-46" data-mp="3w3fqk2kavbpu">
                  MEGACASO DE INVESTIGACIÓN
                </span>
                <h3 className="font-heading text-xl md:text-4xl font-black text-[#1E1E1E]" data-id="element-47" data-mp="33f0d3kgth1gm">
                  ¿Podrás demostrar que Sofía es inocente?
                </h3>
                <p className="text-[15px] md:text-lg text-gray-700 leading-relaxed" data-id="element-48" data-mp="2f7wtjdrigeol">
                  47.700 sospechosos, 18 pistas y una sola respuesta posible. Cada pista descarta nombres hasta que solo queda el verdadero culpable.
                </p>
                <div className="flex flex-wrap gap-2 justify-center md:justify-start" data-id="element-49" data-mp="2p38c6761i61m">
                  {['47.700 sospechosos', '18 pistas', 'Una única solución'].map(tag => <span key={tag} className="bg-white border border-gray-200 text-xs md:text-sm font-semibold text-gray-800 px-3 py-1.5 rounded-full" data-id="element-50" data-mp="1whotx5n0s6d5">{tag}</span>)}
                </div>
              </div>
            </div>
          </div>

          {/* Libro 2: Sopicidios */}
          <div className="bg-white rounded-3xl p-6 md:p-12 mb-6 md:mb-8 border border-gray-200 shadow-sm" data-id="element-51" data-mp="2b61teclbg7ce">
            <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center" data-id="element-52" data-mp="1dqxq0jlsx865">
              <div className="order-1 md:order-2 flex justify-center" data-id="element-53" data-mp="1ioz74yzo2xez">
                <img src={COVER_SOPICIDIOS} alt="Sopicidios" className="w-[68%] md:w-full max-w-xs mx-auto rounded-lg book-shadow transform rotate-2" loading="lazy" data-id="element-54" data-mp="1in4k9f4u4v89" />
              </div>
              <div className="order-2 md:order-1 space-y-4 text-center md:text-left" data-id="element-55" data-mp="3ryosj1in68sc">
                <span className="inline-block bg-[#1E1E1E] text-white font-bold px-3 py-1 rounded-full text-[11px] md:text-xs tracking-wider" data-id="element-56" data-mp="3mx97h9ggs29y">
                  SOPAS DE LETRAS CRIMINALES
                </span>
                <h3 className="font-heading text-xl md:text-4xl font-black text-[#1E1E1E]" data-id="element-57" data-mp="3d1xr6mpeqn03">
                  El asesino está escondido entre las letras
                </h3>
                <p className="text-[15px] md:text-lg text-gray-700 leading-relaxed" data-id="element-58" data-mp="349dy01rvxamn">
                  80 escenas del crimen donde tenés que encontrar al culpable, el arma y el lugar buscando entre las letras e interpretando cada pista.
                </p>
                <div className="flex flex-wrap gap-2 justify-center md:justify-start" data-id="element-59" data-mp="2pb21pw8fc3w0">
                  {['80 casos criminales', '4 niveles', 'Soluciones incluidas'].map(tag => <span key={tag} className="bg-[#F7F1E3] text-xs md:text-sm font-semibold text-gray-800 px-3 py-1.5 rounded-full" data-id="element-60" data-mp="2flv8te4pvtug">{tag}</span>)}
                </div>
              </div>
            </div>
          </div>

          {/* Libro 3: Murdoku */}
          <div className="bg-[#5E1A8A] rounded-3xl p-6 md:p-12 mb-6 md:mb-8 text-white shadow-xl relative overflow-hidden" data-id="element-61" data-mp="2antmmkbzveer">
            <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-62" data-mp="2yez5l8d8emta"></div>
            <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center relative z-10" data-id="element-63" data-mp="33dk6zb47zcjb">
              <div className="order-1 md:order-1 flex justify-center" data-id="element-64" data-mp="2pm5k2t76yr6z">
                <img src={COVER_MURDOKU} alt="Murdoku" className="w-[68%] md:w-full max-w-xs mx-auto rounded-lg book-shadow transform -rotate-2" loading="lazy" data-id="element-65" data-mp="2pjt2wi99ckuz" />
              </div>
              <div className="order-2 md:order-2 space-y-4 text-center md:text-left" data-id="element-66" data-mp="3hbidjucau4o9">
                <span className="inline-block bg-[#F97316] text-white font-bold px-3 py-1 rounded-full text-[11px] md:text-xs tracking-wider" data-id="element-67" data-mp="3m534x3je00eh">
                  LÓGICA + SUDOKU + MISTERIO
                </span>
                <h3 className="font-heading text-xl md:text-4xl font-black text-white" data-id="element-68" data-mp="15p6lfeykuhfv">
                  Resolvé 80 crímenes usando solamente la lógica
                </h3>
                <p className="text-[15px] md:text-lg text-white/85 leading-relaxed" data-id="element-69" data-mp="1fgkotxtng1ea">
                  Sospechosos, habitaciones, objetos y pistas en un tablero. Completá las tablas de deducción y descubrí quién fue en cada caso.
                </p>
                <div className="flex flex-wrap gap-2 justify-center md:justify-start" data-id="element-70" data-mp="11nv37ui18yhp">
                  {['80 acertijos', 'Tablas de deducción', 'Respuestas incluidas'].map(tag => <span key={tag} className="bg-white/10 border border-white/20 text-xs md:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-71" data-mp="wn73mkfqn9bv">{tag}</span>)}
                </div>
              </div>
            </div>
          </div>

          {/* Libro 4: Viaje al Pasado */}
          <div className="bg-[#2A0B42] rounded-3xl p-6 md:p-12 text-white shadow-xl relative overflow-hidden border border-[#F97316]/40" data-id="element-72" data-mp="hnl7mgs94ny8">
            <div className="absolute inset-0 bg-grid-pattern opacity-5" data-id="element-73" data-mp="mm69slr2dhpb"></div>
            <div className="absolute top-0 right-0 w-72 h-72 bg-[#F97316] rounded-full blur-3xl opacity-20 -translate-y-1/2 translate-x-1/4" data-id="element-74" data-mp="qmq5rlzwif9v"></div>
            <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center relative z-10" data-id="element-75" data-mp="10lp70jic78mu">
              <div className="order-1 md:order-2 flex justify-center" data-id="element-76" data-mp="15kse09hvnoxg">
                <img src={COVER_VIAJE} alt="Murdoku: Viaje al Pasado" className="w-[68%] md:w-full max-w-xs mx-auto rounded-lg book-shadow transform rotate-2" loading="lazy" data-id="element-77" data-mp="15ixtgwaipytw" />
              </div>
              <div className="order-2 md:order-1 space-y-4 text-center md:text-left" data-id="element-78" data-mp="1ecat0h337yoy">
                <span className="inline-flex items-center gap-1.5 bg-[#F97316] text-white font-bold px-3 py-1 rounded-full text-[11px] md:text-xs tracking-wider" data-id="element-79" data-mp="1jdi4aq4fvg0d">
                  <Clock size={13} data-id="element-80" data-mp="1yfq6zz3pht1i" />
                  NUEVO LIBRO INCLUIDO
                </span>
                <h3 className="font-heading text-xl md:text-4xl font-black text-white" data-id="element-81" data-mp="1tfknj67lbcui">
                  Viajá al pasado y resolvé 80 nuevos misterios
                </h3>
                <p className="text-[15px] md:text-lg text-white/85 leading-relaxed" data-id="element-82" data-mp="1oiu5idc8676g">
                  Piratas, faraones y aldeas antiguas: investigá crímenes ambientados en otras épocas conectando testimonios, objetos y escenarios.
                </p>
                <div className="flex flex-wrap gap-2 justify-center md:justify-start" data-id="element-83" data-mp="2c7wmrk2y5y0f">
                  {['80 nuevos acertijos', 'Misterios de época', 'Pistas y testimonios'].map(tag => <span key={tag} className="bg-white/10 border border-[#F97316]/40 text-xs md:text-sm font-semibold px-3 py-1.5 rounded-full" data-id="element-84" data-mp="23etdlnzc47bl">{tag}</span>)}
                </div>
                <p className="text-[#FFB27A] font-bold text-base md:text-lg pt-1" data-id="element-85" data-mp="2v5hcsuhg72mm">
                  Cada página es un nuevo viaje.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. Bonus Murdle */}
      <section className="py-14 md:py-20 bg-[#1E1E1E] text-white relative overflow-hidden" data-id="element-86" data-mp="y6h1owiofrlq">
        <div className="absolute top-10 left-6 opacity-5" data-id="element-87" data-mp="jhcipd425jck"><Search size={120} data-id="element-88" data-mp="oh781c86q0vi" /></div>
        <div className="absolute bottom-10 right-6 opacity-5" data-id="element-89" data-mp="og5laaht3pxy"><FileText size={120} data-id="element-90" data-mp="oeuioe03ko8f" /></div>

        <div className="max-w-5xl mx-auto px-5 md:px-6 relative z-10 text-center" data-id="element-91" data-mp="ah66duk3ipez">
          <span className="inline-flex items-center gap-2 bg-[#F97316] text-white font-black tracking-widest text-[11px] md:text-sm uppercase px-4 py-1.5 rounded-full mb-4" data-id="element-92" data-mp="fh20n22zr2hc">
            <Gift size={15} data-id="element-93" data-mp="lmf5lgh8ewk" />
            SOLO POR HOY · BONUS GRATIS INCLUIDOS
          </span>
          <h2 className="font-heading text-2xl md:text-5xl font-black mb-3 leading-tight" data-id="element-94" data-mp="5k60pkr5rooe">
            2 libros Murdle <span className="text-[#F97316]" data-id="element-95" data-mp="1zwdq6ikpndcs">de regalo</span> con tu compra
          </h2>
          <p className="text-sm md:text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-96" data-mp="1ztzzelx2cnb1">
            Se agregan solos a tu pedido, sin costo extra y sin pasos adicionales. Si la promo se cierra, el pack vuelve a tener únicamente los 4 libros principales.
          </p>

          <div className="grid sm:grid-cols-2 gap-4 md:gap-6 mb-8 text-left" data-id="element-97" data-mp="3u4zpqx72t529">
            {[{
            cover: COVER_MURDLE_1,
            title: 'Murdle Vol. 1',
            desc: 'Acertijos para analizar pistas, relacionar sospechosos y descubrir al culpable.'
          }, {
            cover: COVER_MURDLE_2,
            title: 'Murdle Vol. 2',
            desc: 'Nuevos escenarios, objetos y sospechosos para seguir investigando.'
          }].map(book => <div key={book.title} className="bg-[#2A2A2A] p-5 md:p-6 rounded-3xl border border-[#F97316]/30 flex flex-col sm:flex-row items-center text-center sm:text-left gap-4 relative" data-id="element-98" data-mp="byustwbvjrxf">
                <span className="absolute -top-2 right-4 bg-[#F97316] text-white text-[10px] font-black px-2.5 py-1 rounded-full shadow-lg" data-id="element-99" data-mp="2dpy5ss98lil5">GRATIS</span>
                <img src={book.cover} alt={book.title} className="w-24 md:w-28 shrink-0 rounded-lg shadow-xl" loading="lazy" data-id="element-100" data-mp="1rw0x7rzf6v5g" />
                <div data-id="element-101" data-mp="1wtslmc0uvz4w">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-[#F97316] mb-1.5" data-id="element-102" data-mp="21mlvtff3fzod">{book.title}</h3>
                  <p className="text-sm text-gray-300" data-id="element-103" data-mp="26m83l9c5knps">{book.desc}</p>
                </div>
              </div>)}
          </div>

          <a href="#compra" onClick={scrollToCheckout} className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-[#F97316] hover:bg-[#FB8B3C] text-white font-black text-base md:text-xl py-4 px-8 md:px-10 rounded-xl shadow-[0_6px_0_#9A3412] hover:shadow-[0_3px_0_#9A3412] hover:translate-y-1 transition-all duration-200 uppercase tracking-wide" data-id="element-104" data-mp="18z82rseino9j">
            QUIERO LOS 6 LIBROS
            <Download size={20} data-id="element-105" data-mp="2uahma2e2kvcp" />
          </a>
          <p className="text-xs text-gray-500 mt-4" data-id="element-106" data-mp="2udm1dut2pbi5">Los bonus se entregan junto al resto de los archivos.</p>
        </div>
      </section>

      {/* 6. Todo lo que incluye */}
      <section className="py-14 md:py-20 bg-[#5E1A8A] text-white relative overflow-hidden" data-id="element-107" data-mp="nm7h4j0w9rl2">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-108" data-mp="iofotnwc83gc"></div>
        <div className="max-w-6xl mx-auto px-5 md:px-6 relative z-10" data-id="element-109" data-mp="dw5vdxw0kl9b">
          <h2 className="font-heading text-2xl md:text-5xl font-black text-center mb-8 md:mb-14" data-id="element-110" data-mp="8ye0cv02oj0w">
            Todo esto está incluido
          </h2>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-111" data-mp="40kvc5ai9v27">
            {[{
            title: '6 libros digitales completos',
            icon: FileText
          }, {
            title: 'Más de 300 acertijos y casos',
            icon: Brain
          }, {
            title: 'Soluciones explicadas',
            icon: CheckCircle2
          }, {
            title: 'Listos para imprimir',
            icon: Search
          }, {
            title: 'Celular, tablet o compu',
            icon: Smartphone
          }, {
            title: 'Acceso inmediato',
            icon: Zap
          }].map(item => <div key={item.title} className="bg-white/10 backdrop-blur-sm p-4 md:p-5 rounded-2xl flex items-center gap-3 md:gap-4 border border-white/20" data-id="element-112" data-mp="2c9f66u6sfvdl">
                <div className="bg-[#F97316] p-2.5 rounded-lg text-white shrink-0" data-id="element-113" data-mp="22ghkygaevsba">
                  <item.icon size={22} data-id="element-114" data-mp="1xizin8qwgbc9" />
                </div>
                <span className="font-semibold text-sm md:text-base" data-id="element-115" data-mp="1xglrhazcbj9z">{item.title}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. Testimonios */}
      <section className="py-14 md:py-20 bg-[#F7F1E3] overflow-hidden" data-id="element-116" data-mp="1oggiwxieueu8">
        <div className="max-w-6xl mx-auto px-5 md:px-6 text-center mb-8 md:mb-10" data-id="element-117" data-mp="1jjq40dicdpae">
          <h2 className="font-heading text-2xl md:text-5xl font-black text-[#3C1361]" data-id="element-118" data-mp="1ekdka1mroyc1">
            Lo que dicen quienes ya lo compraron
          </h2>
        </div>

        <TestimonialCarousel data-id="element-119" data-mp="3dubusfimy3ik" />
      </section>

      {/* 8. CTA Final / Compra */}
      <section id="compra" className="py-16 md:py-24 bg-gradient-to-b from-[#3C1361] to-[#1E1E1E] text-white relative overflow-hidden" data-id="element-120" data-mp="38vii2pb6agjg">
        <div className="absolute inset-0 bg-grid-pattern opacity-10" data-id="element-121" data-mp="3lfp98u0s179h"></div>

        <div className="max-w-6xl mx-auto px-5 md:px-6 relative z-10" data-id="element-122" data-mp="3ldunxellfd4v">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6 md:gap-y-8 items-center" data-id="element-123" data-mp="3q7pft5bcqyf1">

            {/* Título */}
            <div className="md:col-start-2 md:row-start-1 text-center md:text-left" data-id="element-124" data-mp="2yfremyj9mas3">
              <div className="flex flex-wrap gap-2 justify-center md:justify-start mb-4" data-id="element-125" data-mp="2yhuba1exb25s">
                <span className="inline-block bg-[#F97316] text-white font-bold px-3 md:px-4 py-1.5 rounded-full text-xs md:text-sm tracking-wider" data-id="element-126" data-mp="32jfmlibt78dv">
                  PACK 6 EN 1
                </span>
                <span className="inline-block bg-white/15 border border-[#F97316]/60 text-[#FFB27A] font-bold px-3 md:px-4 py-1.5 rounded-full text-xs md:text-sm tracking-wider" data-id="element-127" data-mp="3cdfyc31ljbvk">
                  2 BONUS GRATIS
                </span>
              </div>
              <h2 className="font-heading text-2xl md:text-5xl font-black text-white leading-tight" data-id="element-128" data-mp="20czy4g9k9fw">
                Descargalo hoy y empezá tu primera investigación
              </h2>
            </div>

            {/* Mockup */}
            <div className="md:col-start-1 md:row-start-1 md:row-span-2 relative flex justify-center w-full" data-id="element-129" data-mp="bytzhpt9pwdk">
              <div className="absolute inset-0 bg-[#7B2CBF] opacity-30 blur-[40px] rounded-full scale-75" data-id="element-130" data-mp="6y683314ndit"></div>
              <img src={PACK_IMAGE_URL} alt={PACK_ALT} className="relative z-10 w-full max-w-none md:max-w-[560px] h-auto object-contain drop-shadow-[0_20px_40px_rgba(0,0,0,0.6)]" loading="lazy" data-id="element-131" data-mp="3fdpvhlf4a1py" />
            </div>

            {/* Caja de oferta */}
            <div className="md:col-start-2 md:row-start-2 w-full" data-id="element-132" data-mp="3ke45va46xnr5">
              <div className="bg-white/10 backdrop-blur-md border border-white/20 p-5 md:p-8 rounded-3xl w-full text-center md:text-left" data-id="element-133" data-mp="2wpb8rabu19uy">
                <div className="mb-4 flex flex-col md:flex-row items-center md:justify-between gap-2 md:gap-3" data-id="element-134" data-mp="2rpov4zs3drlm">
                  <span className="text-xs md:text-sm font-bold text-[#F97316] uppercase tracking-wider" data-id="element-135" data-mp="176upre9wyr03">
                    4 libros + 2 de regalo
                  </span>
                  <Countdown data-id="element-136" data-mp="xbawz0qnc8fk" />
                </div>

                <div className="text-4xl md:text-6xl font-black text-white mb-2 font-heading" data-id="element-137" data-mp="x8f3bolu05wx">
                  {price.amount}
                </div>
                <p className="text-[13px] md:text-sm text-white/80 font-medium mb-5" data-id="element-138" data-mp="1pzymj8ifhjyx">
                  Pago único · Acceso inmediato · Producto digital
                </p>

                <a href={CHECKOUT_URL} className="block w-full bg-[#F97316] hover:bg-[#FB8B3C] text-white font-black text-base md:text-2xl py-4 md:py-5 px-4 md:px-6 rounded-xl shadow-[0_8px_0_#9A3412] hover:shadow-[0_4px_0_#9A3412] hover:translate-y-1 transition-all duration-200 uppercase text-center" data-id="element-139" data-mp="1gys6t1nlsd6q">
                  COMPRAR EL PACK MISTERIOS
                </a>

                <div className="flex items-center justify-center md:justify-start gap-2 mt-5 text-[13px] md:text-sm text-white/80" data-id="element-140" data-mp="9iccfbtnl5zw">
                  <ShieldCheck size={18} className="text-[#F97316]" data-id="element-141" data-mp="l0le2s2i2tpw" />
                  <span data-id="element-142" data-mp="kzaaas921lys">Acceso inmediato después del pago</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 9. FAQ */}
      <section className="py-14 md:py-20 bg-[#F7F1E3]" data-id="element-143" data-mp="b0ui0lyak6np">
        <div className="max-w-4xl mx-auto px-5 md:px-6" data-id="element-144" data-mp="18pmpmo6mqkze">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-center text-[#3C1361] mb-8 md:mb-10" data-id="element-145" data-mp="13rl4lxpn8bla">
            Preguntas Frecuentes
          </h2>
          <FAQAccordion data-id="element-146" data-mp="yqx5eor9gofz" />
        </div>
      </section>

      {/* 10. Footer */}
      <footer className="bg-[#1E1E1E] text-white/70 py-12 border-t border-white/10" data-id="element-147" data-mp="upv5s6tfmadh">
        <div className="max-w-6xl mx-auto px-5 md:px-6" data-id="element-148" data-mp="3jiz8fwobfgu6">
          <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-8 mb-10 text-center md:text-left" data-id="element-149" data-mp="3jge5t5g70wvd">
            <div className="max-w-md" data-id="element-150" data-mp="1uzw54fseu1hf">
              <div className="flex items-center justify-center md:justify-start gap-3 mb-3" data-id="element-151" data-mp="1v0xt1kuiyigk">
                <div className="bg-[#5E1A8A] p-2 rounded-lg" data-id="element-152" data-mp="1z17vwon0ssr7">
                  <Brain className="text-[#F97316]" size={24} data-id="element-153" data-mp="23zj8360sffcl" />
                </div>
                <h3 className="font-heading font-bold text-xl md:text-2xl text-white tracking-wide" data-id="element-154" data-mp="28q814ps48kdu">
                  Atlas Digital Hub
                </h3>
              </div>
              <p className="text-sm text-white/60 mb-3" data-id="element-155" data-mp="2drxam0zowpzt">
                Tienda digital de recursos, libros y productos descargables
              </p>
              <div className="inline-flex items-center gap-2 text-xs font-semibold bg-white/5 px-3 py-1.5 rounded-full text-[#FFB27A]" data-id="element-156" data-mp="2mrc293rlf6lw">
                <ShieldCheck size={14} data-id="element-157" data-mp="2rn9gn4jaq2w1" />
                Producto 100% digital · Uso personal
              </div>
            </div>

            <div className="flex flex-col items-center md:items-end gap-3 text-sm" data-id="element-158" data-mp="xb2s741e5pls">
              <h4 className="font-heading font-bold text-white tracking-widest mb-1" data-id="element-159" data-mp="20m8lf9i6pmzl">
                PACK MISTERIOS
              </h4>
              <a href="#" className="hover:text-white transition-colors" data-id="element-160" data-mp="1vnx7amkuwqbk">
                Términos y Condiciones
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-161" data-mp="29o838410wv3l">
                Políticas de Privacidad
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-162" data-mp="2jl4cibyqxl97">
                Contacto
              </a>
            </div>
          </div>

          <div className="pt-6 border-t border-white/10 text-center text-xs text-white/40 flex flex-col md:flex-row justify-between items-center gap-3" data-id="element-163" data-mp="2el8agi9m03wa">
            <p data-id="element-164" data-mp="2oc2wbliy11h7">
              © {new Date().getFullYear()} Atlas Digital Hub. Todos los derechos reservados.
            </p>
            <p data-id="element-165" data-mp="32asvr7t8jd8q">Las marcas y títulos pertenecientes a terceros se ofrecen únicamente cuando existe autorización legal para su distribución.</p>
          </div>
        </div>
      </footer>
    </div>;
}